var map = {
	"./about1.png": 930,
	"./about_img1.png": 589,
	"./about_img2.png": 590,
	"./acknowledgements_img1.png": 574,
	"./acknowledgements_img2.png": 575,
	"./acknowledgements_img3.png": 576,
	"./adb_logo.png": 578,
	"./bcn_logo.png": 580,
	"./bcst_logo.png": 581,
	"./bl_logo.svg": 593,
	"./bli_full_logo.png": 594,
	"./bli_logo_transparent50.png": 931,
	"./bnhs_logo.png": 579,
	"./cms_energytaskforce_logo.png": 583,
	"./download_icon.png": 591,
	"./eBird_logo.png": 585,
	"./eakpf_logo.png": 577,
	"./earth_icon.svg": 588,
	"./ebook_icon.png": 592,
	"./error_icon.svg": 404,
	"./exit_button.svg": 587,
	"./high_sensitivity_card.png": 595,
	"./home_page_video.mp4": 596,
	"./ibat_logo.png": 586,
	"./landing_page_image.png": 932,
	"./logo.svg": 933,
	"./low_sensitivity_card.png": 597,
	"./moderate_sensitivity_card.png": 598,
	"./protected_planet_logo.png": 584,
	"./right_panel/bird_placeholder_1.png": 667,
	"./right_panel/bird_placeholder_2.png": 668,
	"./right_panel/bird_placeholder_3.png": 669,
	"./right_panel/bird_placeholder_4.png": 670,
	"./right_panel/coral_reef.png": 671,
	"./right_panel/india_offshore_wind.png": 672,
	"./right_panel/india_onshore_wind.png": 673,
	"./right_panel/india_powerline_distribution.png": 674,
	"./right_panel/india_powerline_transmission.png": 675,
	"./right_panel/india_solar.png": 676,
	"./right_panel/mangrove.png": 677,
	"./right_panel/nepal_onshore_wind.png": 678,
	"./right_panel/nepal_powerline_distribution.png": 679,
	"./right_panel/nepal_powerline_transmission.png": 680,
	"./right_panel/nepal_solar.png": 681,
	"./right_panel/seagrass.png": 682,
	"./right_panel/thailand_offshore_wind.png": 683,
	"./right_panel/thailand_onshore_wind.png": 684,
	"./right_panel/thailand_powerline_distribution.png": 685,
	"./right_panel/thailand_powerline_transmission.png": 686,
	"./right_panel/thailand_solar.png": 687,
	"./right_panel/vietnam_offshore_wind.png": 688,
	"./right_panel/vietnam_onshore_wind.png": 689,
	"./right_panel/vietnam_powerline_distribution.png": 690,
	"./right_panel/vietnam_powerline_transmission.png": 691,
	"./right_panel/vietnam_solar.png": 692,
	"./transition_video.mp4": 599,
	"./very_high_sensitivity_card.png": 600,
	"./vietnature_logo.png": 582
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 929;